import React, { useEffect } from 'react';

import { Box } from '@sunwisesoftware/sunwise-ui';
import { push } from 'connected-react-router';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';

import AlurackSolarPlanner from './3DPlanner/AlurackSolarPlanner';
import * as actions from './actions';
import { HeaderLayout, AddSegmentFormContainer } from './components';
import * as selectors from './selectors';

const ContainerV2 = ({
    generateProposal,
    handleClickBreadcrumb,
    handleClickEdit,
    isDisabledEdition,
    initialFetching,
    isFetchingOfferInfoPatern,
    isFetchingParentFieldSegment,
    offerInfoPatern,
    redirect,
    reset,
}) => {
    const { t } = useTranslation();
    const { uid: commercialOfferId } = useParams();

    useEffect(() => {
        initialFetching(commercialOfferId);
        return () => reset();
    }, [commercialOfferId]);

    if (isFetchingParentFieldSegment || isFetchingOfferInfoPatern) return null;

    return (
        <>
            <HeaderLayout
                commercialOfferId={commercialOfferId}
                currentBreadcrumb={t('Layout')}
                generateProposal={generateProposal}
                handleClickBreadcrumb={handleClickBreadcrumb}
                handleClickEdit={handleClickEdit}
                offerInfoPatern={offerInfoPatern}
                proposalId={offerInfoPatern?.proposalId}
                redirect={redirect}
                renderStatus={offerInfoPatern?.renderStatus}
                showGenerateProposal
            />

            <Box
                sx={{
                    position: 'relative',
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flex: 1,
                    overflow: 'hidden',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flex: 1,
                        flexDirection: 'column',
                        position: 'relative',
                        width: '100%',
                    }}
                >
                    <Box
                        sx={{
                            position: 'relative',
                            width: '100%',
                            height: '100%',
                        }}
                    >
                        <Box
                            sx={{
                                height: '100%',
                                left: 0,
                                position: 'absolute',
                                top: 0,
                                width: '100%',
                            }}
                        >
                            <AlurackSolarPlanner
                                viewMode="3d"
                                isDisabledEdition={isDisabledEdition}
                            />
                        </Box>
                    </Box>
                </Box>
            </Box>
            <AddSegmentFormContainer />
        </>
    );
};

ContainerV2.propTypes = {
    generateProposal: PropTypes.func,
    handleClickBreadcrumb: PropTypes.func,
    handleClickEdit: PropTypes.func,
    isDisabledEdition: PropTypes.bool,
    initialFetching: PropTypes.func,
    isFetchingOfferInfoPatern: PropTypes.bool,
    isFetchingParentFieldSegment: PropTypes.bool,
    offerInfoPatern: PropTypes.object,
    redirect: PropTypes.func,
    reset: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
    isDisabledEdition: selectors.getIsDisabledEdition,
    isFetchingOfferInfoPatern: selectors.getIsFetchingOfferInfoPatern,
    isFetchingParentFieldSegment: selectors.getIsFetchingParentFieldSegment,
    offerInfoPatern: selectors.getOfferInfoPaternData,
});

const mapDispatchToProps = (dispatch) => ({
    generateProposal: (proposalId) =>
        dispatch(actions.generateProposal(proposalId)),
    handleClickBreadcrumb: (contactId, projectId, proposalId) =>
        dispatch(
            actions.handleClickBreadcrumb(contactId, projectId, proposalId),
        ),
    handleClickEdit: (layoutId, proposalId) =>
        dispatch(actions.prepareEdit(layoutId, proposalId)),
    initialFetching: (id) => dispatch(actions.initialFetching(id)),
    redirect: (path) => dispatch(push(path)),
    reset: () => dispatch(actions.resetValues()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContainerV2);
